const state = {
  // 注册来源
  _registerSuccessSource: {
    route: {},
    name: '初始来源'
  }
};

const getters = {
  registerSuccessSource: (state) => state._registerSuccessSource
};

const mutations = {
  // 记录注册来源
  setRegisterSuccessSource(state, payload) {
    state._registerSuccessSource = Object.assign(state._registerSuccessSource, payload);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
